/**
 * FCI Evolution Chart — ApexCharts area chart with period filters.
 *
 * Reads data-history JSON (array of {x: 'YYYY-MM-DD', y: float}) from the
 * .chart-canvas element and renders an ApexCharts area chart.
 * Period buttons (15 DÍAS, 1 MES, YTD, MÁX) filter the dataset.
 */
function initFciCharts() {
    document.querySelectorAll('.evolution-section').forEach(section => {
        const canvas = section.querySelector('.chart-canvas');
        if (!canvas) return;

        let fullData;
        try {
            fullData = JSON.parse(canvas.dataset.history || '[]');
        } catch (e) {
            return;
        }

        if (fullData.length < 2) {
            canvas.innerHTML = '<p class="chart-no-data">El gráfico de evolución estará disponible en los próximos días, una vez que se acumule el historial de precios.</p>';
            return;
        }

        function filterByPeriod(period) {
            if (!fullData.length) return fullData;
            const latest = new Date(fullData[fullData.length - 1].x);
            let cutoff;
            if (period === '15d') {
                cutoff = new Date(latest);
                cutoff.setDate(cutoff.getDate() - 15);
            } else if (period === '1m') {
                cutoff = new Date(latest);
                cutoff.setMonth(cutoff.getMonth() - 1);
            } else if (period === 'ytd') {
                cutoff = new Date(latest.getFullYear(), 0, 1);
            } else {
                return fullData;
            }
            return fullData.filter(pt => new Date(pt.x) >= cutoff);
        }

        const initialData = filterByPeriod('ytd');

        const chartOptions = {
            chart: {
                type: 'area',
                height: 340,
                toolbar: { show: false },
                zoom: { enabled: false },
                animations: { enabled: true, speed: 400 },
                fontFamily: 'inherit',
            },
            series: [{ name: 'VCP', data: initialData }],
            xaxis: {
                type: 'datetime',
                labels: {
                    datetimeUTC: false,
                    style: { colors: '#7F7F7F', fontSize: '12px' },
                    datetimeFormatter: { year: 'yyyy', month: "MMM 'yy", day: 'dd MMM' },
                },
                axisBorder: { show: false },
                axisTicks: { show: false },
            },
            yaxis: {
                labels: {
                    style: { colors: '#7F7F7F', fontSize: '12px' },
                    formatter: val => val.toLocaleString('es-AR', {
                        minimumFractionDigits: 2,
                        maximumFractionDigits: 2,
                    }),
                },
            },
            stroke: {
                curve: 'smooth',
                width: 2,
                colors: ['#35A2A8'],
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.3,
                    opacityTo: 0.02,
                    stops: [0, 100],
                    colorStops: [
                        { offset: 0, color: '#35A2A8', opacity: 0.3 },
                        { offset: 100, color: '#35A2A8', opacity: 0.02 },
                    ],
                },
            },
            dataLabels: { enabled: false },
            grid: {
                borderColor: '#F3F3F3',
                strokeDashArray: 4,
                xaxis: { lines: { show: false } },
            },
            tooltip: {
                x: { format: 'dd MMM yyyy' },
                y: {
                    formatter: val => '$ ' + val.toLocaleString('es-AR', {
                        minimumFractionDigits: 4,
                        maximumFractionDigits: 4,
                    }),
                },
            },
            markers: { size: 0 },
        };

        const chart = new ApexCharts(canvas, chartOptions);
        chart.render();

        // Period filter buttons
        const periodLabels = { '15 DÍAS': '15d', '1 MES': '1m', 'YTD': 'ytd', 'MÁX': 'max' };
        const periodButtons = section.querySelectorAll('.control-btn');

        periodButtons.forEach(btn => {
            btn.addEventListener('click', () => {
                periodButtons.forEach(b => b.classList.remove('active'));
                btn.classList.add('active');
                const filtered = filterByPeriod(periodLabels[btn.textContent.trim()] || 'max');
                chart.updateOptions({
                    series: [{ name: 'VCP', data: filtered }],
                    xaxis: {
                        min: filtered.length ? new Date(filtered[0].x).getTime() : undefined,
                        max: filtered.length ? new Date(filtered[filtered.length - 1].x).getTime() : undefined,
                    },
                });
            });
        });
    });
}
